import { render, staticRenderFns } from "./property-toKnow.vue?vue&type=template&id=2d275af6&"
import script from "./property-toKnow.vue?vue&type=script&lang=js&"
export * from "./property-toKnow.vue?vue&type=script&lang=js&"
import style0 from "./property-toKnow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports